// loading.interceptor.ts
import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { finalize } from 'rxjs/operators';
import { AppState } from '../../state/app.state';
import { setLoading } from '../../state/actions/loading.actions';
import { RequestCounterService } from '../services/request-counter.service';
import { SKIP_LOADING } from './skip-loading.token';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store<AppState>);
  const requestCounter = inject(RequestCounterService);

  const skipLoading = req.context.get(SKIP_LOADING);
  if (skipLoading) {
    return next(req);
  }

  requestCounter.increment();

  store.dispatch(setLoading(true));

  return next(req).pipe(
    finalize(() => {
      requestCounter.decrement();
      if (!requestCounter.hasPendingRequests()) {
        store.dispatch(setLoading(false));
      }
    })
  );
};
